export const formatPhoneNumber = (params) => {
    const value = params.value;
    if (value && value[0] != '(' && value != 'Unknown') {
        const phoneNumber = String(value);
        params.value = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
        return params
    }
    return params;
}